var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7549 14.2539H14.9649L14.6849 13.9839C15.6649 12.8439 16.2549 11.3639 16.2549 9.75391C16.2549 6.16391 13.3449 3.25391 9.75488 3.25391C6.16488 3.25391 3.25488 6.16391 3.25488 9.75391C3.25488 13.3439 6.16488 16.2539 9.75488 16.2539C11.3649 16.2539 12.8449 15.6639 13.9849 14.6839L14.2549 14.9639V15.7539L19.2549 20.7439L20.7449 19.2539L15.7549 14.2539ZM9.75488 14.2539C7.26488 14.2539 5.25488 12.2439 5.25488 9.75391C5.25488 7.26391 7.26488 5.25391 9.75488 5.25391C12.2449 5.25391 14.2549 7.26391 14.2549 9.75391C14.2549 12.2439 12.2449 14.2539 9.75488 14.2539Z",
    fill: "#475569",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.d7bc87e04f9fe886fb8b1cb9ec014e22.svg";
export { ForwardRef as ReactComponent };